export default "__VITE_ASSET__CVp12cq3__"